import { useQuery as defaultUseQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { useCurrentAccountId } from '@zapier/payment/src/hooks/useCurrentAccountId';
import {
  ApolloInjection,
  currencyRulesetQuery as currencyRulesetQueryData,
} from '@zapier/payment/src/types';

type Input = {
  accountId?: number | undefined;
} & ApolloInjection;

export const currencyRulesetQuery = gql`
  query currencyRulesetQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currencyRuleset {
        currency
        method
        processor
        submethod
        submethodDisplay
      }
    }
  }
`;

export function useCurrencyRuleset(props: Input = {}) {
  const currentAccount = useCurrentAccountId(props);
  const useQuery = props?.useQuery || defaultUseQuery;
  const accountId = props.accountId || currentAccount?.accountId;

  // @ts-ignore
  const { data, error, loading } = useQuery<currencyRulesetQueryData>(
    currencyRulesetQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  return {
    error: error ? 'There was an issue loading data.' : undefined,
    isLoading: loading,
    currencyRuleset: data?.account?.currencyRuleset ?? [],
  };
}
